import { Box, styled, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const ErrorWrapper = styled(Box)({
  width: '100%',
  minHeight: '100px',
  height: 'max-content',
  backgroundColor: palette.alerts.error_light,
  borderRadius: '12px',
  marginBottom: '24px',
  padding: '16px',
}) as typeof Box;

export const ErrorWrapperHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
}) as typeof Box;

export const ErrorWrapperTitle = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '22px',
  color: palette.text.header,
}) as typeof Typography;

export const ErrorWrapperDescription = styled(Typography)({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '22px',
  color: palette.text.body,
  paddingLeft: '32px',
}) as typeof Typography;
